<template>
  <ErrorReportDetail />
</template>

<script>

import ErrorReportDetail from '@/views/components/error-report-detail.vue';

export default {
  name: 'ApplicationAnalysisErrorReportDetail',
  components: {
    ErrorReportDetail,
  },
};
</script>
